import * as React from 'react'

import { Box, Divider, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import badges from 'modules/billing/lib/assets/badges.png'
import { formatPrice } from 'modules/billing/lib/prices'
import { useF25PricingContext } from 'modules/onboarding/components/Pricing/F25PricingContext'
import { DEFAULT_CURRENCY } from 'modules/onboarding/lib/pricing/plans/utils'

import ItemInfo, { OrderItem } from './_ItemInfo'

const Header = ({ period }: { period: string }) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween" flexWrap="wrap" gap="s12">
      <Text.Header2 weight="semibold">
        {i18n.t('pricing_plans.billing_information.summary_card.title')}
      </Text.Header2>
      <Tag>{period}</Tag>
    </Box>
  )
}

const Badges = () => {
  return (
    <Box alignSelf="center" paddingTop="s16">
      <img src={badges} width="300px" />
    </Box>
  )
}

const F25SummaryCard = () => {
  const today = new Date()
  const futureDate = new Date(today)
  futureDate.setDate(today.getDate() + 30)

  const { allPlans, period, computeTotalPrice, isYearly, countryFloor, seats } =
    useF25PricingContext()
  const currency = allPlans.f25Plans[0]?.pricing?.currency || DEFAULT_CURRENCY
  const totalPrice = computeTotalPrice()

  const getOrderSummary = (): OrderItem[] => {
    return allPlans.f25Plans
      .concat(allPlans.f25Addons)
      .filter((plan) => plan.isSelected)
      .map((plan) => {
        return {
          name: plan.title,
          isYearly: period === 'year',
          isMainPlan: !!plan.includedAddons?.length,
          includedSeats: countryFloor,
          perSeatPrice: plan.pricing.getSeatsPrice(period),
          feePrice: plan.pricing.getFeePrice(period),
          tieredPrice: plan.pricing.getTieredPrice(period),
          stairstepPrice: plan.pricing.getStairstepPrice(period, seats),
        }
      })
  }

  const getPeriodPayment = (): string => {
    const periodPayment = isYearly()
      ? i18n.t('pricing_plans.billing_information.summary_card.yearly_payment')
      : i18n.t('pricing_plans.billing_information.summary_card.monthly_payment')

    return periodPayment
  }

  const orderSummary = getOrderSummary()

  return (
    <>
      <Box
        alignSelf="center"
        background="grey000White"
        padding="s32"
        gap="s16"
        borderRadius={{
          all: 'abs008',
        }}
        style={{ maxWidth: '480px', minWidth: '380px', maxHeight: '70vh', overflowY: 'auto' }}
      >
        <Header period={getPeriodPayment()} />
        <Divider />
        <Box
          paddingY="s8"
          paddingRight="s8"
          gap="s16"
          minHeight="s80"
          maxHeight="s300"
          style={{ overflowY: 'auto' }}
        >
          {orderSummary.map((orderItem) => (
            <ItemInfo
              key={orderItem.name}
              {...orderItem}
              currency={currency}
              countryFloor={countryFloor}
              seats={seats}
            />
          ))}
        </Box>
        <Divider />
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text.Header2 weight="semibold">
            {i18n.t('pricing_plans.billing_information.summary_card.total')}
          </Text.Header2>
          <Text.Header2 weight="semibold">{formatPrice(totalPrice, currency)}</Text.Header2>
        </Box>
      </Box>
      <Badges />
    </>
  )
}

export default F25SummaryCard
